import { render, staticRenderFns } from "./pickupInformationDetails.vue?vue&type=template&id=425db15b&scoped=true"
import script from "./pickupInformationDetails.vue?vue&type=script&lang=js"
export * from "./pickupInformationDetails.vue?vue&type=script&lang=js"
import style0 from "./pickupInformationDetails.vue?vue&type=style&index=0&id=425db15b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425db15b",
  null
  
)

export default component.exports